import { c as _c } from "react/compiler-runtime";
import { Flag } from '@7f-ui/components/flag/flag';
import type { AccommodationRoomFacility } from '@data-access/graphql/schema.types';
import { Bathtub, Bed, Campfire, CastleTurret, City, Coffee, CookingPot, Couch, Desk, DeviceTablet, Fan, GameController, Island, Martini, Monitor, Mountains, Network, Oven, Phone, PicnicTable, Plant, PottedPlant, Shower, SwimmingPool, ThermometerCold, ThermometerHot, Towel, Tree, Vault, WashingMachine, Waves, Wheelchair, WifiHigh } from '@phosphor-icons/react';
import type { PropsWithChildren } from 'react';
export type AccommodationRoomFacilitiesFlagsProps = PropsWithChildren<{
  facilities: AccommodationRoomFacility[];
}>;
export function AccommodationRoomFacilitiesFlags(t0) {
  const $ = _c(7);
  const {
    facilities,
    children
  } = t0;
  let t1;
  if ($[0] !== facilities) {
    t1 = facilities.map(_temp);
    $[0] = facilities;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <li>{children}</li>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <ul className="flex flex-wrap gap-3">{t1}{t2}</ul>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(facility) {
  return <AccommodationRoomFacilityFlag key={facility.id} facility={facility} />;
}
const HIGHLIGHT_ICONS = new Map([[296, Waves], [297, Waves], [298, Mountains], [488, Tree], [295, SwimmingPool], [489, SwimmingPool], [490, SwimmingPool], [491, SwimmingPool], [492, CastleTurret], [493, City], [494, Waves], [495, City], [496, City], [291, PottedPlant], [299, Plant], [294, ThermometerHot], [290, Towel], [300, Wheelchair], [289, Fan], [497, WifiHigh], [293, WifiHigh], [292, Shower], [498, Wheelchair], [499, Wheelchair], [500, undefined], [288, Vault], [501, Martini], [502, Bathtub], [503, Desk], [504, Bed], [505, Bathtub], [506, Shower], [507, undefined], [508, Shower], [509, Towel], [510, undefined], [511, DeviceTablet], [512, Monitor], [513, Shower], [514, Shower], [515, Island], [516, Network], [517, GameController], [518, Phone], [519, ThermometerCold], [520, WashingMachine], [521, Coffee], [522, undefined], [523, Couch], [524, Campfire], [525, PicnicTable], [526, Couch], [527, undefined], [528, CookingPot], [529, undefined], [530, Campfire], [531, undefined], [532, Couch], [533, Oven], [534, Oven], [535, Oven]]);
type AccommodationRoomFacilityFlagProps = {
  facility: AccommodationRoomFacility;
};
function AccommodationRoomFacilityFlag(t0) {
  const $ = _c(5);
  const {
    facility
  } = t0;
  let t1;
  if ($[0] !== facility.id) {
    t1 = HIGHLIGHT_ICONS.get(facility.id);
    $[0] = facility.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== facility.name || $[3] !== t1) {
    t2 = <li><Flag Icon={t1}>{facility.name}</Flag></li>;
    $[2] = facility.name;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}